import { Link } from '@tanstack/react-router'

import { TableCell } from '@/components/table/table'

import { cn } from '@/lib/utils'

interface Props {
  applicantPathId: number
  receiptNumber: string
  noPadding?: boolean
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

export const CasesTableCell: React.FC<Props> = ({
  applicantPathId,
  receiptNumber,
  noPadding,
  disabled,
  children,
  className,
}) => {
  return (
    <TableCell className={cn('h-[49px] overflow-hidden px-0', className)}>
      <Link
        disabled={disabled}
        className={cn('m-[-10em] block p-[10em]', 'select-text')}
        draggable={false}
        to={`/applicants/${applicantPathId}/cases/${receiptNumber}`}
      >
        <div className={cn('py-2', noPadding ? 'px-0' : 'px-4', 'flex items-center')}>{children}</div>
      </Link>
    </TableCell>
  )
}
